<template>
	<div class="report_detail">
		<headerCard :detail="detail" />
		<doctorCard
			v-if="detail.isFeedback"
			title="报告反馈"
			:date="detail.feedbackTime||''"
			:doctor="doctor"
			:list="[
                {value:detail.perilFeedback,label:'危险因素反馈'},
                {value:detail.medicationFeedback,label:'用药依从性反馈'}
            ]"
		/>
		<van-tabs v-if="detail.dateType" class="mt-28" background="transparent" v-model="active">
			<van-tab title="血压"><reportPressure ref="reportPressure" :detail="detail" /> </van-tab>
			<van-tab title="血糖"><reportSugar ref="reportSugar" :detail="detail" /> </van-tab>
			<van-tab title="血脂 "><reportFat :detail="detail" /></van-tab>
			<van-tab title="用药依从性"><reportCompliance :detail="detail" /></van-tab>
		</van-tabs>
		<monthReport :detail="detail" v-else-if="detail.id" />
	</div>
</template>
<script>
import headerCard from './components/report-detail-header.vue'

import doctorCard from './components/report-doctor-card.vue'

import reportPressure from './components/report-pressure.vue'
import reportSugar from './components/report-sugar.vue'
import reportFat from './components/report-fat.vue'
import reportCompliance from './components/report-compliance.vue'
import monthReport from './components/report-month.vue'
export default {
    name: 'reportDetail',
    components: { headerCard, reportPressure, reportSugar, reportFat, reportCompliance, monthReport, doctorCard },

    data () {
        return {
            active: 0,
            detail: {
                pateintDetail: {}
            },
            doctor: {},
            tags: []
        }
    },
    computed: {
        detailId () {
            return this.$route.params.id
        },
        isDoctor () {
            return this.$route.params.type === 'doctor'
        }
    },
    watch: {
        active: function (val) {
            if (val === 1) {
                this.$nextTick(() => {
                    this.$refs.reportSugar.init()
                })
            }
        }
    },
    created () {
        this.getDetail()
    },
    methods: {
        getDetail () {
            this.$api.report.getReportDetail(this.detailId).then(({ code, data }) => {
                if (!code) {
                    let detail = data
                    detail.patientDetail = {
                        questionnaireType: data.questionnaireType,
                        multiplierValue: data.multiplierValue,
                        mainDiagnosis: data.mainDiagnosis
                    }
                    if (detail.scPatientMedicationRecordList) {
                        let arr = []
                        detail.scPatientMedicationRecordList.map(v => {
                            let date = this.$moment(v.gmtCreate).format('YYYY-MM-DD')
                            let index = arr.findIndex(r => r.date === date)
                            if (index > -1) {
                                let state = arr[index].state
                                arr[index].list.push(v.reminderStatus)
                                if (state !== 3) {
                                    if (state === 2) {
                                        if (v.reminderStatus === 1) {
                                            arr[index].state = 3
                                        }
                                    }
                                    if (state === 1) {
                                        if (v.reminderStatus === 2) {
                                            arr[index].state = 3
                                        }
                                    }
                                }

                            } else {
                                arr.push({
                                    date,
                                    list: [v.reminderStatus],
                                    state: v.reminderStatus
                                })
                            }
                        })
                        detail.reminderDate = arr
                    }


                    if (detail.patientTag) {
                        detail.patientTag = JSON.parse(detail.patientTag)
                        //格式化标签
                        this.tags = detail.patientTag
                        let arr1 = ['高血压', '糖尿病']
                        let arr2 = ['高血压', '出血性卒中']

                        if (arr1.every(this.existName)) {
                            detail.pressurePersonType = 1
                        } else if (arr2.every(this.existName)) {
                            detail.pressurePersonType = 1
                        } else {
                            detail.pressurePersonType = 2
                        }
                    }

                    this.detail = detail
                    if (this.detail.feedbackDoctorId) {
                        this.getDoctor()
                    }


                    this.$nextTick(() => {
                        if (this.detail.dateType) {
                            this.$refs.reportPressure.init()
                        }
                    })
                }
            })
        },
        existName (val) {
            return this.tags.indexOf(val) > -1
        },
        getDoctor () {
            this.$api.doctor.getDoctorInfoById(this.detail.feedbackDoctorId).then(res => {
                if (!res.code) {
                    this.doctor = res.data
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.report_detail {
	padding: 40px 32px;
	background-image: url('../../assets/img/report_bg.png');
	background-size: 100vw auto;
	background-repeat: no-repeat;
}
</style>